<template>
  <div class="part7">
    <div class="partBox">
      <div class="swiperPageSevent pr">
        <!-- 轮播 -->
        <div class="swiper">
          <div class="swiper-wrapper">
            <div
              v-for="(item, index) in imgList"
              :key="index"
              class="swiper-slide"
            >
              <img :src="item.src" alt="" style="width: 100%" />
              <!-- <div>{{ item }}</div> -->
            </div>
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-prev"></div>
        <div class="swiper-next"></div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <div class="swiper-line"></div>
      </div>
      <div class="fourbtn">
        <!-- <p v-for="(item, index) in 4" :key="index">
        <img :src="itemImg(item)" alt="" @click="toGroup(item)" />
      </p> -->
        <div
          class="fourbtn_item"
          v-for="(item, index) in foutlist"
          :key="index"
        >
          <img
            :src="item.img"
            alt=""
            class="btnimg"
            @click="toGroup(item.url, index)"
          />
          <!-- <p @click="toGroup(1)">官方Facebook</p> -->
        </div>
      </div>
      <pageEight></pageEight>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swipe
import pageEight from "./pageEight.vue";
export default {
  name: "pageSeven",
  data() {
    return {
      imgList: [
        {
          src: require("@/assets/images/page7/feature1.png"),
        },
        {
          src: require("@/assets/images/page7/feature2.png"),
        },
        {
          src: require("@/assets/images/page7/feature3.png"),
        },
        {
          src: require("@/assets/images/page7/feature4.png"),
        },
        {
          src: require("@/assets/images/page7/feature5.png"),
        },
        {
          src: require("@/assets/images/page7/feature6.png"),
        },
        {
          src: require("@/assets/images/page7/feature7.png"),
        },
      ],
      foutlist: [
        {
          img: require("@/assets/images/page7/FACEBOOK.png"),
          url: "https://www.facebook.com/XM.DXZ",
        },
        {
          img: require("@/assets/images/page7/welfare.png"),
          url: "https://www.facebook.com/groups/xm.dxz",
        },
        {
          img: require("@/assets/images/page7/discord.png"),
          url: "https://discord.com/invite/XYjSSKu4KN",
        },
        {
          img: require("@/assets/images/page7/Discussion.png"),
          url: "https://forum.gamer.com.tw/A.php?bsn=71938",
        },
      ],
    };
  },
  mounted() {
    this.createdSwiper();
    this.$bus.$on("point6", () => {
      this.anchor();
    });
  },
  methods: {
    // gogoing(url) {
    //   console.log(url);
    // },
    //定位
    anchor() {
      let ele = document.getElementsByClassName("part7")[0];
      let eletop = ele.offsetTop;
      window.scrollTo({
        top: eletop,
        behavior: "smooth",
      });
    },
    // itemImg(item) {
    //   return require(`@/images/page3/item${item}.png`);
    // },
    toGroup(item, index) {
      console.log(index);
      // let url = "";
      // switch (item) {
      //   case 1:
      //     url = "https://www.facebook.com/XM.YYS/";
      //     break;
      //   case 2:
      //     url = "https://www.facebook.com/groups/1352033725541543";
      //     break;
      //   case 3:
      //     url = "https://discord.gg/qQWYbP44aF";
      //     break;
      //   case 4:
      //     url = this.$utils.isPhone()
      //       ? "https://forum.gamer.com.tw/B.php?bsn=76418"
      //       : "https://forum.gamer.com.tw/A.php?bsn=76418";
      //     break;
      // }
      if (index == 1) {
        this.$xmlog.joinFbGroup(() => {
          location.href = item;
        });
      } else {
        location.href = item;
      }
    },
    createdSwiper() {
      new Swiper(".swiperPageSevent .swiper", {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        //前进后退按钮
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        loop: true, //循环模式选项
        // effect: "fade",
        // observer: true,
        // observeParents: true,
        pagination: {
          el: ".swiper-pagination", //换页器与哪个标签关联
          clickable: true, //分页器是否可以点击
        },
      });
    },
  },
  components: {
    pageEight,
  },
};
</script>

<style lang="less" scoped>
.part7 {
  width: 100%;
  position: relative;
  .partBox {
    margin-top: 4.7rem;
    .swiperPageSevent {
      width: 90%;
      margin: 0.5rem auto 0;
      text-align: center;
      padding: 0.45rem 0.5rem 0.4rem 0.5rem;
      font-size: 0.3rem;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 92%;
        pointer-events: none;
        width: 100%;
        background: url("../assets/images/page7/feature_bg.png") no-repeat;
        background-size: 100% 100%;
      }
      .swiper {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      .swiper-pagination {
        // background: url("@/assets/images/page7/swiper_strip.png") no-repeat;
        // background-position: center;
        width: 90%;
        transform: translateX(-50%);
        left: 50%;
        position: relative;
        bottom: -0.27rem;
        /deep/.swiper-pagination-bullet {
          margin: 0 0.3rem;
          background: #60acdd;
          opacity: 1;
          // opacity: 0;
          &:first-of-type {
            margin-left: 0;
          }
          &:last-of-type {
            margin-right: 0;
          }
        }
        /deep/.swiper-pagination-bullet-active {
          width: 0.3rem;
          height: 0.3rem;
          position: relative;
          background: url("@/assets/images/page7/swiper_chiose.png") no-repeat;
          background-size: 100% 100%;
          top: 0.1rem;
        }
      }
      .swiper-line {
        height: 1px;
        width: 90%;
        background: #60acdd;
        position: absolute;
        bottom: 0.23rem;
        left: 50%;
        transform: translateX(-50%);
      }
      .swiper-next {
        right: 0rem;
        top: 50%;
        transform: translateY(-82%);
        background: url("@/assets/images/arrows_right.png");
        position: absolute;
        width: 0.82rem;
        height: 1rem;
        z-index: 95;
        cursor: pointer;
        background-repeat: no-repeat;
        background-size: 100%;
      }
      .swiper-prev {
        left: 0rem;
        top: 50%;
        transform: translateY(-82%);
        background: url("@/assets/images/arrows_left.png");
        position: absolute;
        background-size: 100%;
        width: 0.82rem;
        height: 1rem;
        z-index: 95;
        cursor: pointer;
        background-repeat: no-repeat;
      }
    }
    .fourbtn {
      display: flex;
      justify-content: space-between;
      width: 80%;
      margin: 0.5rem auto;
      text-align: center;
      .fourbtn_item {
        cursor: pointer;
        width: 100%;
        .btnimg {
          width: 1.5rem;
        }
        // p {
        //   font-size: 0.2rem;
        //   // width: 49%;
        //   // border: 1px solid #000;
        //   // height: 1rem;
        //   // line-height: 1rem;
        // }
      }
    }
  }
}
</style>